import initialState from './initialState';
import { FETCH_PARTNERS, SELECT_PARTNER, RECEIVE_PARTNERS, RECEIVE_PARTNER } from '../actions/actionTypes';

export default function partner(state = initialState.partner, action) {
  switch (action.type) {
    case FETCH_PARTNERS:
      return action;
    case RECEIVE_PARTNERS:
      return {
        ...state,
        options: action.options
      };
    case RECEIVE_PARTNER:
      return {
        ...state,
        fundingPartnerData: action.partner
      };
    case SELECT_PARTNER:
      return {
        ...state,
        selected: action.partner
      };
    default:
      return state;
  }
}
